if(window.innerWidth < 991){

// date format js
var dateFormat=function(){var token=/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,timezone=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,timezoneClip=/[^-+\dA-Z]/g,pad=function(val,len){val=String(val);len=len||2;while(val.length<len)val="0"+val;return val};return function(date,mask,utc){var dF=dateFormat;if(arguments.length==1&&Object.prototype.toString.call(date)=="[object String]"&&!/\d/.test(date)){mask=date;date=undefined}
date=date?new Date(date):new Date;if(isNaN(date))throw SyntaxError("invalid date");mask=String(dF.masks[mask]||mask||dF.masks["default"]);if(mask.slice(0,4)=="UTC:"){mask=mask.slice(4);utc=!0}
var _=utc?"getUTC":"get",d=date[_+"Date"](),D=date[_+"Day"](),m=date[_+"Month"](),y=date[_+"FullYear"](),H=date[_+"Hours"](),M=date[_+"Minutes"](),s=date[_+"Seconds"](),L=date[_+"Milliseconds"](),o=utc?0:date.getTimezoneOffset(),flags={d:d,dd:pad(d),ddd:dF.i18n.dayNames[D],dddd:dF.i18n.dayNames[D+7],m:m+1,mm:pad(m+1),mmm:dF.i18n.monthNames[m],mmmm:dF.i18n.monthNames[m+12],yy:String(y).slice(2),yyyy:y,h:H%12||12,hh:pad(H%12||12),H:H,HH:pad(H),M:M,MM:pad(M),s:s,ss:pad(s),l:pad(L,3),L:pad(L>99?Math.round(L/10):L),t:H<12?"a":"p",tt:H<12?"am":"pm",T:H<12?"A":"P",TT:H<12?"AM":"PM",Z:utc?"UTC":(String(date).match(timezone)||[""]).pop().replace(timezoneClip,""),o:(o>0?"-":"+")+pad(Math.floor(Math.abs(o)/60)*100+Math.abs(o)%60,4),S:["th","st","nd","rd"][d%10>3?0:(d%100-d%10!=10)*d%10]};return mask.replace(token,function($0){return $0 in flags?flags[$0]:$0.slice(1,$0.length-1)})}}();dateFormat.masks={"default":"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:ss",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"};dateFormat.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"]};Date.prototype.format=function(mask,utc){return dateFormat(this,mask,utc)}

// end date format js

//to handle scrolling on gentle diamond landing page
$(document).on('click','.page-gentle-diamonds a[data-modal="appointment-booker"]', function() { 
        fullpage_api.setAutoScrolling(0);
    });
    $(document).on('click','.page-gentle-diamonds .mod-Modal_Close', function() { 
        fullpage_api.setAutoScrolling(1);
    });
// end handling

//show country code on phone number
  var country_code = null;
$.getJSON('https://ipinfo.io/', function(data){
    country_code = data.country;
    var input = document.querySelector("#phone");
    var iti = window.intlTelInput(input, {
      initialCountry: country_code,
      utilsScript: "utils.js",
    });
    var input = document.querySelector("#phone");
    input.addEventListener('keyup', function() {
      if (input.value.trim()) {
        if (iti.isValidNumber()) {
          input.classList.remove("error");
        } else {
          input.classList.add("error");
        }
      }
    });
});

var weekDaysArray = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
$(document).on('click','#changeCalendermode',function(){
    var active = $(this).attr('data-active');
    if(active == 'daily'){
        $(this).attr('data-active','weekly');
        $('#viewtype').val('weekly');
    }else if(active == 'weekly'){
         $(this).attr('data-active','daily');
        $('#viewtype').val('daily');
    }
    $(this).text(active);
    var value = $('#selectedDateSlot').val();
    setDatepicker();
})
    $(document).ready(function() {    
	var today = new Date();
       var stringD = String(today);
       stringD = stringD.split(' ')[5];
       $('#localTimeZone').val(stringD);
       $("#customTimezone option").each(function(){
            var optionTimezone = $(this).data('timezone');
            optionTimezone = optionTimezone.replace(':','');
            if(stringD == optionTimezone){
                  $("#customTimezone").val($(this).val());
                  $("#customTimezone").attr('title',$(this).data('timezone'));
                  $("#customTimezone_label").attr('title',$(this).data('timezone'));
                  $("#customTimezone_label").text($(this).data('timezone'));
            }
       });
      
    $('#tabs li:not(:first)').addClass('inactive').hide();
    $('.tab-content').hide();
    $('.tab-content:first').show();
        
    $('#tabs li').click(function(){
        var t = $(this).find('a').attr('id');
        $('#tabs li').removeClass('active');
        $('#tabs li').addClass('inactive');
        $(this).removeClass('inactive');
        $(this).addClass('active').show();
        $('.tab-content').hide();
		if(t != 'tab_3'){
            $("#tab_3").parent().hide();
        }
        $('#'+ t + 'C').fadeIn('slow');
    });
  });

  var enableDays = [];
    
    
  $(document).ready(function(){
    $('.setster_loadbox').show();
    var companyid = $('#companyid').val();
    var api_url = "https://www.setster.com/api/v2/location?company_id="+companyid;
     $.ajax({
        url: api_url,
          contentType: "application/json",
          dataType: 'json',
          success: function(result){
              var html = '';
              if(result.data){
                  $(result.data).each(function(index,element){
                    var storeaddress = element.street1+", "+element.street2+", "+element.city+" "+element.zip;
                    html = '<div data-locationid="'+element.id+'" data-companyid="'+companyid+'" class="location_list" data-lat="'+element.lat+'" data-lng="'+element.lng+'" data-storename="'+element.name+'"  data-storeaddress="'+storeaddress+'" data-phone="'+element.phone+'">'+element.name+'<span></span></div>';
                    $(html).appendTo("#setsterContent");     
                    $('#timezoneid').val(element.timezone_id);           
                    $('#timezone').val(element.timezone.friendly);    
					$('#sethostTimezone').text(element.timezone.friendly);           
                    $('#sethostTimezone').attr('title',element.timezone.friendly);     
                  });
                }
                $('#setsterContent .location_list:first').click();
          }
      })

  });
  $(document).on('click','.location_list',function(){
    $('.setster_loadbox').show(); 
	$('.location_list').removeClass('selected');
    $(this).addClass('selected');
    var companyid = $(this).attr('data-companyid');
    var locationid = $(this).attr('data-locationid');
    var storename = $(this).attr('data-storename');
    var lat = $(this).attr('data-lat');
    var lng = $(this).attr('data-lng');
    var phone = $(this).attr('data-phone');
    var storeaddress = $(this).attr('data-storeaddress');
    $('#slectedStorename').val(storename);
    $('#locationid').val(locationid);
    $.ajax({
          url: "https://www.setster.com/api/v2/company/"+companyid+"/service",
          contentType: "application/json",
          dataType: 'json',
          success: function(result){
            if(result.data){
              $(result.data).each(function(index,element){
                  $('#servceid').val(element.id);
                  $('#book_appointment').attr('data-servceid',element.id);
                  $('#book_appointment').attr('data-companyid',companyid);
                  $('#book_appointment').attr('data-locationid',locationid);
                  $('#makeanappointment').show();                 
                  $('.setster_loadbox').hide(); 
                  initMap(lat, lng, storename, phone, storeaddress);
              });
            }
          }
        });
  });
  
  $(document).on('click','#book_appointment',function(){
    $('.setster_loadbox').show(); 
    var getCurrentDate = fetchCurrentDate();
    var companyid = $('#companyid').val();
    var locationid = $('#locationid').val();
    var servceid = $('#servceid').val();
    var timezoneid = $('#timezoneid').val();
    $('#tab_2').click();
      $.ajax({
          url: "https://setster.com/api/v2/company/"+companyid+"/availability?location_id="+locationid+"&service_id="+servceid+"&start_date="+getCurrentDate+"&return=times&timezone_id="+timezoneid+"&t=weekly&no_of_weeks=12",
          contentType: "application/json",
          dataType: 'json',
          success: function(result){
            if(result.data){
              $(result.data.times).each(function(index,element){
                    for (var key in element) { 
                        if (element.hasOwnProperty(key)) { 
                            enableDays.push(key);
                        } 
                    }  
                    
              });
              	var splitDate = getCurrentDate.split('-');
              	getNextMonthAppointment(splitDate[0],splitDate[1])
            }

				$('.ui-datepicker-calendar td').not('.ui-state-disabled').first().click();
          }
        });
  });
  function getNextMonthAppointment(year, month){
	$('.setster_loadbox').show(); 
    var getCurrentDate = year+'-'+(parseInt(month)+1)+'-'+1;
    var companyid = $('#companyid').val();
    var locationid = $('#locationid').val();
    var servceid = $('#servceid').val();
    var timezoneid = $('#timezoneid').val();
		 $.ajax({
          url: "https://setster.com/api/v2/company/"+companyid+"/availability?location_id="+locationid+"&service_id="+servceid+"&start_date="+getCurrentDate+"&return=times&timezone_id="+timezoneid+"&t=weekly&no_of_weeks=12",
          contentType: "application/json",
          dataType: 'json',
          success: function(result){
            if(result.data){
              $.each(result.data.times,function(key,element){
                	enableDays.push(key);
              });
				setDatepicker();
            }
          }
        });
  }
function setDatepicker(){
    if($('#viewtype').val()=='daily'){
          $( "#showcalender" ).datepicker({ 
            minDate: '0',
            showOtherMonths: true,
            selectOtherMonths: true,
            maxDate: "+12m",
            onChangeMonthYear: function(year, month, inst){
              // set date to 1st on year or month change
              getNextMonthAppointment(year,month)
            },
            dateFormat: 'yy-mm-dd',
            beforeShowDay: enableAllTheseDays
          }).removeClass('weekly');
        $('#showcalender').trigger('change');
      }else{
          $( "#showcalender" ).datepicker({ 
                minDate: '0',
                showOtherMonths: true,
                selectOtherMonths: true,
                maxDate: "+12m",
                onChangeMonthYear: function(year, month, inst){
                  // set date to 1st on year or month change
                  getNextMonthAppointment(year,month)
                },
                dateFormat: 'yy-mm-dd',
                beforeShowDay: enableAllTheseDays
            }).addClass('weekly')
            $('#showcalender').trigger('change');
      }
      // $('.setster_loadbox').hide(); 
      
}
  $(document).on("change", "#showcalender", function () {
        $('.setster_loadbox').show(); 
        var companyid = $('#companyid').val();
        var locationid = $('#locationid').val();
        var servceid = $('#servceid').val();
        var timezoneid = $('#timezoneid').val();
        var value = $(this).val();
        var currentPeriod = dateFormat(value,"dddd mmmm d, yyyy");
        $('#currentPeriod').text(currentPeriod);
        if($('#viewtype').val()=='daily'){
          $('.dailyview').show();
          $('.weeklyview').hide();
          $('.ui-datepicker-calendar td.ui-datepicker-current-day').parent().removeClass('activeweek');
          $('.ui-datepicker-calendar td').removeClass('activeweekdays');
           $.ajax({
              url: "https://setster.com/api/v2/company/"+companyid+"/availability?location_id="+locationid+"&service_id="+servceid+"&start_date="+value+"&return=times&timezone_id="+timezoneid+"&t=daily&no_of_weeks=1",
              contentType: "application/json",
              dataType: 'json',
          success: function(result){
                if(result.data){
                    $("#timeinam").html('AM');
                    $("#timeinpm").html('PM');
                    $("#slotselected").val(value);
                    $("#selectedDateSlot").val(value);                    
                      for (var i = 0; i < result.data.times[value].length; i++) {
                        var time = result.data.times[value][i];
                          var formated_time = getFormatedTime(time);
                            var html="<div class='getselectedtime' data-slotdate='"+value+"' data-time='"+time+"' data-timeinampm='"+formated_time.time+"' data-servceid ='"+servceid+"' data-currentPeriod='"+currentPeriod+"' data-slot = '"+formated_time.slottime+"'>"+formated_time.time+"</div>";
                          if(formated_time.ampm == "am"){
                            $(html).appendTo("#timeinam");
                          }else{
                              $(html).appendTo("#timeinpm");
                          }
                      }
                  }
                  $('.setster_loadbox').hide(); 
            }
          });
        }else{
            
            var getCurrentDate = value;
            $.ajax({
              url: "https://setster.com/api/v2/company/"+companyid+"/availability?location_id="+locationid+"&service_id="+servceid+"&start_date="+getCurrentDate+"&return=times&timezone_id="+timezoneid+"&t=weekly&no_of_weeks=1",
              contentType: "application/json",
              dataType: 'json',
              success: function(result){
               if(result.data){
                    $('#timeulli ul').html('<li><span>00:00</span></li><li><span>01:00</span></li><li><span>02:00</span></li><li><span>03:00</span></li><li><span>04:00</span></li><li><span>05:00</span></li><li><span>06:00</span></li><li><span>07:00</span></li><li><span>08:00</span></li><li><span>09:00</span></li><li><span>10:00</span></li><li><span>11:00</span></li><li><span>12:00</span></li><li><span>13:00</span></li><li><span>14:00</span></li><li><span>15:00</span></li><li><span>16:00</span></li><li><span>17:00</span></li><li><span>18:00</span></li><li><span>19:00</span></li><li><span>20:00</span></li><li><span>21:00</span></li><li><span>22:00</span></li><li><span>23:00</span></li>');
                     $("#selectedDateSlot").val(getCurrentDate);                     
                    var html = '';
                    for (var i = 0; i < weekDaysArray.length; i++) {
                        html +='<li class="cd-schedule__group">';
                        html +='<div class="cd-schedule__top-info"><span>'+weekDaysArray[i].substr(0, 2)+'</span></div><ul class="'+weekDaysArray[i]+'">';
                      
                          html +='</ul></li>';
                    }   
                    $('#setweeklyCalenderdata').html(html);
                    $("#slotselected").val(getCurrentDate);
                    var sDate = new Date(getCurrentDate);
                      var firstday = new Date(sDate.setDate(sDate.getDate() - sDate.getDay()));
                          firstday = dateFormat(firstday,"mmmm d yyyy");
                      var lastday = new Date(sDate.setDate(sDate.getDate() - sDate.getDay()+6));
                          lastday = dateFormat(lastday,"mmmm d yyyy");
                      var currentPeriodweek = firstday+' - '+lastday;
                    $('#currentweeklyPeriod').text(currentPeriodweek);
                    $.each(result.data.times,function(key,element){
                      var d = new Date(key);
                      var currntDateDay = d.getDay();
                          var childhtml = '';
                          for (var i = 0; i < element.length; i++) {
                              var value = element[i];
                              var formated_time = getFormatedTime(value);
                               var totime = addMinutesToTime(value,40);                               
                                currentPeriod = dateFormat(d,"dddd mmmm d, yyyy");
                              childhtml += '<li class="cd-schedule__event getselectedtime" data-time="'+value+'" data-timeinampm="'+formated_time.time+'" data-servceid ="'+servceid+'" data-slotdate="'+key+'" data-currentPeriod="'+currentPeriod+'" data-slot = "'+formated_time.slottime+'"><a data-start="'+value.substr(0, 5)+'" data-end="'+totime+'" title="'+formated_time['slottime']+'"></a></li>';
                          }
                          $(childhtml).appendTo("."+weekDaysArray[currntDateDay]);
                    });      
					$('.cd-schedule__timeline span.timehide').hide();
                     $('.dailyview').hide();
                    $('.weeklyview').show();   
                    $('.js-cd-schedule').removeClass('js-schedule-loaded');  
                     weeklyCalender(); 
					$('#timeulli li span').addClass('showTime');
                     $('.showTime').each(function(index,ele){
                          var time = $(this).text();
                          formated_time = getFormatedTime(time);
                           $(this).text(formated_time.time.substr(0, 2).replace(':','')+' '+formated_time.ampm);
                     }) 
					$('.ui-datepicker-calendar td.ui-datepicker-current-day').parent().addClass('activeweek');
                      $('.ui-datepicker-calendar .activeweek').find('td').addClass('activeweekdays');
                }
                $('.setster_loadbox').hide(); 
              }
            });
        }   

    })

  function fetchCurrentDate(){
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy +'-' + mm + '-' + dd;
      return today;
  }
  function getFormatedTime(time){
      var timeString = time;
      var totime = addMinutesToTime(time,40);
      var H = +timeString.substr(0, 2);
      var h = (H % 12) || 12;
      var ampm = H < 12 ? "am" : "pm";
      timeString = h + timeString.substr(2, 3)+' '+ampm;

      var H = +totime.substr(0, 2);
      var h = (H % 12) || 12;
      var ampm = H < 12 ? "am" : "pm";
      totime = h + totime.substr(2, 3)+' '+ampm;

      var return_array = [];
      return_array['slottime'] = timeString+' - '+totime;
      return_array['time'] = timeString;
      return_array['ampm'] = ampm;
      return return_array;  
  }
  function enableAllTheseDays(date) {
        var sdate = $.datepicker.formatDate( 'yy-mm-dd', date)
        if($.inArray(sdate, enableDays) != -1) {
            return [true];
        }else{
        	return [false];
        }
    }
  $(document).on('click','#timeslot_section .getselectedtime',function(){
        var selectedTimeampm = $(this).data('timeinampm');
        var selectedTime = $(this).data('time');
        var selectedDate = $(this).attr('data-currentPeriod');
        var slotdate = $(this).attr('data-slotdate');
        var slotime = $(this).data('slot');
        var timezone = $('#timezone').val();
        $('#timeslot_section .getselectedtime').removeClass('selectedtime');
        $(this).addClass('selectedtime');
        $('#slotselected').val(slotdate+' '+selectedTime.substr(0, 5));
        $('#slectedtimedateinampm').val(selectedDate+' '+selectedTimeampm);
        $('#selectedDate').text(selectedDate);
    	$('#selectedDateSlot').val(slotdate);
        $('#selectedTime').text(slotime+' '+timezone);
        $('#tab_3').click();
    });
function addMinutesToTime(time, minsAdd) {
  function z(n){ 
     return (n<10? '0':'') + n;
    };
  var bits = time.split(':');
  var mins = bits[0]*60 + +bits[1] + +minsAdd;
  return z(mins%(24*60)/60 | 0) + ':' + z(mins%60);  
} 

$('#checkConfirmForm').on('submit',function(e){
      e.preventDefault();
        var values = {};
        $.each($('#checkConfirmForm').serializeArray(), function(i, field) {
            values[field.name] = field.value;
        });
        var errorcount = 0;
        var showalerttext = '';
        if(values.name.trim() == ''){
          showalerttext +='Your name is required';
          errorcount++;
        }
        var re = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        if(values.email.trim() == ''){
          showalerttext +='\nYour email is required';
          errorcount++;
        }else if(!re.test($.trim(values.email))){
          showalerttext +='\nEmail address is invalid';
          errorcount++;          
        }
        if(values.email.trim() != '' && (re.test($.trim(values.email)))){
          if(values.email_confirm.trim() !=  values.email){
            showalerttext +='\nThe confirmed email address is different';
            errorcount++;
          }
        }
        if(values.phone.trim() == ''){
          showalerttext +='\nMissing or Invalid phone number';
          errorcount++;
        }else if($('#phone').hasClass('error')){
		  showalerttext +='\nMissing or Invalid phone number';
          errorcount++;	
		}
        if(errorcount == 0){
		$('.setster_loadbox').show(); 
          var senddata = '{"data": {"company_id": '+values.companyid+',"client_email": "'+values.email_confirm+'","client_name": "'+values.name+'","client_phone": "'+values.phone+'","client_address": "","employee_id": 0,"location_id": '+values.locationid+',"service_id": '+values.servceid+',"start_date": "'+values.slotselected+'","duration": 0,"note": "'+values.notes+'","status": 0,"subservices": "string","paid": false,"price": 0,"ews_id": "string","custom_fields": {},"timezone_id": '+values.timezoneid+'}}';
            $.ajax({
                url: "https://www.setster.com/api/v2/appointment",
                type: "POST",
                contentType: "application/json",
                dataType: 'json',
                data : senddata,
                success: function(result){
                    $('#checkConfirmForm')[0].reset();
                    $('.setStorename').text($('#slectedStorename').val());
                    $('.setTimeslot').text('on '+$('#slectedtimedateinampm').val());
                    $('#setsterPanelConfirm').hide();
                    $('#tabs li.inactive').addClass('clickDisable');
                    $('#tps_thank_msg').show();					
					$('.setster_loadbox').hide(); 
                },
                error: function (request, status, error) {					
                     if(request.status == 403){
                          alert(request.responseJSON.statusDescription);
                     }else{
                          alert("Something wents wrong. Please try again");
                     }
					$('.setster_loadbox').hide(); 
                }
          });
      }else{
          alert(showalerttext);
      }
      return false;
});
$(document).on('click','#tps_thank_msg .closebtn',function(){
      location.reload();
});
function initMap(lat, long, storename='', phone='', storeaddress='',searchlat = '', searchlng='') {

      var location= new google.maps.LatLng(lat, long);
      var mapEl= document.getElementById('map_canvas');
      var mapOpt= {
          center: location,
          zoom: 14,
          panControl: true,
          disableDefaultUI: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
              styles: [{
              stylers: [{
                saturation: -100
              }]
          }]
      }
      var map = new google.maps.Map(mapEl, mapOpt);
      var marker= new google.maps.Marker({
          position: location,
          map: map,
          icon: $('#mapicon').val()
      });
      var distance = '';
      if(searchlat && searchlng){
         distance = google.maps.geometry.spherical.computeDistanceBetween (new google.maps.LatLng(lat, long), new google.maps.LatLng(searchlat, searchlng));
         distance = distance/1609;
         $('.location_list.selected span').text(Math.round(distance)+'mi');
         distance = ' ('+Math.round(distance)+'mi)';
      }else{
        $('.location_list.selected span').text('');
      }
      var contentString= '<div class="info-window">'+
                            '<p>'+storename+distance+'</p>'+
                            '<div class="info-content">'+
                            '<p>'+storeaddress+'</p>'+
                            '<p>Tel: '+phone+'</p>'+
                            '</div>'+
                            '</div>';

      var infoWindow = new google.maps.InfoWindow({
          content: contentString,
          maxWidth: 400
      });

          infoWindow.open(map, marker);
      marker.addListener('click', function() {
           infoWindow.open(map, marker);
      });
}

function getDistanceMap(){
    var ele = $('.location_list.selected');
    var value = $('#locationsearch').val();
    var storename = $(ele).attr('data-storename');
    var lat = $(ele).attr('data-lat');
    var lng = $(ele).attr('data-lng');
    var phone = $(ele).attr('data-phone');
    var storeaddress = $(ele).attr('data-storeaddress');
    var searchLat = '';
    var searchLng = '';
    if(value!=''){
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': value ,componentRestrictions: {country: 'UK'}}, function(results, status) {
          if(status == google.maps.GeocoderStatus.OK && results[0]) {
              var position = results[0].geometry.location;
              searchLat = position.lat();
              searchLng = position.lng();
              initMap(lat, lng, storename, phone, storeaddress,searchLat,searchLng);
          }else{
            alert('Sorry, you are outside our service area.');
          }
      });
    }else{
      initMap(lat, lng, storename, phone, storeaddress,searchLat,searchLng);
    }
}
$(document).on('click','.showTimezoneLnk',function(){
    $('.timeformatsection').hide();
    $('.timezonesection').show();
});
$(document).on('click','#cancelTimezone',function(){
      $('.timeformatsection').show();
      $('.timezonesection').hide();
});
$(document).on("change", "#customTimezone", function () {
      var setTimezone = $('#customTimezone option:selected').data('timezone');
      $("#customTimezone_label").attr('title',setTimezone);
      $("#customTimezone_label").text(setTimezone);
});
$(document).on('click','#saveTimezone',function(){
      var customTimezone = $('#customTimezone').val();
      $('#timezoneid').val(customTimezone);
      var timezone = $('#customTimezone option:selected').data('timezone');
      $('#timezone').val(timezone);
      $('#customTimezone').attr('title',timezone);
      $('#currentTimezone').text(timezone);
      $('.setster_loadbox').show(); 
        var companyid = $('#companyid').val();
        var locationid = $('#locationid').val();
        var servceid = $('#servceid').val();
        var timezoneid = $('#timezoneid').val();
        var value = $('#selectedDateSlot').val();
        $('#showcalender').val(value);
        $('#showcalender').trigger('change');
        $('.timeformatsection').show();
        $('.timezonesection').hide();                
});

}